export const LOCALES = {
  ENGLISH: 'en-EN',
  RUSSIAN: 'ru-RU'
}